var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.25 48.638c5.24 0 9.488-4.293 9.488-9.588 0-5.295-4.248-9.587-9.487-9.587-5.24 0-9.487 4.292-9.487 9.587s4.247 9.588 9.487 9.588zM30.888 71.659h38.714c0-4.069-1.597-7.97-4.442-10.849a15.114 15.114 0 00-10.728-4.505h-8.35c-4.03 0-7.895 1.617-10.744 4.497a15.436 15.436 0 00-4.45 10.857v0z",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgAvatar;